<form [formGroup]="form_Group" (ngSubmit)="save()">
  <div class="modal-header">
    <h4 class="modal-title black" *ngIf="!user?.id">إضافة مستخدم جديد</h4>
    <h4 class="modal-title black" *ngIf="user?.id">تعديل مستخدم</h4>
    <button type="button" class="close mt-1" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true" style="font-size: 50px;">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-6 col-12">
        <div class="form-group">
          <label for="text" class="mb-3">
            {{"CreateOrUpdateUser.UserType" | translate}}
            <span class="text-danger"> *</span>
          </label>
          <ng-select [qcId]="'user-type'" width="100%" [items]="userTypes" bindValue="id" bindLabel="name"
            formControlName="userType" [multiple]="false" [placeholder]="'Global.Choose' | translate">
          </ng-select>

          <div class="text-danger mt-2">
            <div
              *ngIf="controlHasError('required', 'userType', form_Group) || controlHasError('min', 'userType', form_Group)">
              {{"CreateOrUpdateUser.UserType_Required" | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12">
        <div class="form-group">
          <label for="text" class="mb-3">
            {{"CreateOrUpdateUser.JobID" | translate}}
            <span class="text-danger"> *</span>
          </label>
          <input [qcId]="'user-job-id'" type="text" class="form-control" formControlName="jobId"
            placeholder="{{'CreateOrUpdateUser.JobID_P' | translate }}" />

          <div class="text-danger mt-2">
            <div *ngIf="controlHasError('required', 'jobId', form_Group)">
              {{"CreateOrUpdateUser.JobID_Required" | translate}}
            </div>
            <div
              *ngIf="controlHasError('pattern', 'jobId', form_Group) ||controlHasError('minlength', 'jobId', form_Group) || controlHasError('maxlength', 'jobId', form_Group)">
              {{"CreateOrUpdateUser.JobID_Length" | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12">
        <div class="form-group">
          <label for="text" class="mb-3">
            {{"CreateOrUpdateUser.Name" | translate}}
            <span class="text-danger"> *</span>
          </label>
          <div *ngIf="!user?.id">
            <input [qcId]="'user-name'" type="text" class="form-control" formControlName="name"
              placeholder="{{'CreateOrUpdateUser.Name_P' | translate }}" />

            <div class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'name', form_Group)">
                {{"CreateOrUpdateUser.Name_Required" | translate}}
              </div>
              <div *ngIf="controlHasError('pattern', 'name', form_Group)">
                {{"CreateOrUpdateUser.Name_String" | translate}}
              </div>
              <div
                *ngIf="controlHasError('minlength', 'name', form_Group) || controlHasError('maxlength', 'name', form_Group)">
                {{"CreateOrUpdateUser.Name_Length" | translate}}
              </div>
            </div>
          </div>
          <div *ngIf="user?.id">
            <input [qcId]="'user-name'" type="text" class="form-control" [value]="user?.name"
              placeholder="{{'CreateOrUpdateUser.Name_P' | translate }}" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12">
        <div class="form-group">
          <label for="text" class="mb-3">
            {{"CreateOrUpdateUser.Surname" | translate}}
            <span class="text-danger"> *</span>
          </label>
          <div *ngIf="!user?.id">
            <input [qcId]="'user-surname'" type="text" class="form-control" formControlName="surname"
              placeholder="{{'CreateOrUpdateUser.Surname_P' | translate }}" />

            <div class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'surname', form_Group)">
                {{"CreateOrUpdateUser.Surname_Required" | translate}}
              </div>
              <div *ngIf="controlHasError('pattern', 'surname', form_Group)">
                {{"CreateOrUpdateUser.Surname_String" | translate}}
              </div>
              <div
                *ngIf="controlHasError('minlength', 'surname', form_Group) || controlHasError('maxlength', 'surname', form_Group)">
                {{"CreateOrUpdateUser.Surname_Length" | translate}}
              </div>
            </div>
          </div>
          <div *ngIf="user?.id">
            <input [qcId]="'user-surname'" type="text" class="form-control" [value]="user?.surname"
              placeholder="{{'CreateOrUpdateUser.Surname_P' | translate }}" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12">
        <div class="form-group">
          <label for="text" class="mb-3">
            {{"CreateOrUpdateUser.Email" | translate}}
            <span class="text-danger"> *</span>
          </label>
          <div *ngIf="!user?.id">
            <input [qcId]="'user-email'" type="text" class="form-control" formControlName="email"
              placeholder="{{'CreateOrUpdateUser.Email_P' | translate }}" />

            <div class="text-danger mt-2">
              <div *ngIf="controlHasError('required', 'email', form_Group)">
                {{"CreateOrUpdateUser.Email_Required" | translate}}
              </div>
              <div *ngIf="controlHasError('pattern', 'email', form_Group)">
                {{"CreateOrUpdateUser.Email_String" | translate}}
              </div>
              <div
                *ngIf="controlHasError('minlength', 'email', form_Group) || controlHasError('maxlength', 'email', form_Group)">
                {{"CreateOrUpdateUser.Email_Length" | translate}}
              </div>
            </div>
          </div>
          <div *ngIf="user?.id">
            <input [qcId]="'user-email'" type="text" class="form-control" [value]="user?.email"
              placeholder="{{'CreateOrUpdateUser.Surname_P' | translate }}" readonly />
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-12">
        <div class="form-group">
          <label for="text" class="mb-3">
            {{"CreateOrUpdateUser.Mobile" | translate}}
            <span class="text-danger"> *</span>
          </label>
          <input [qcId]="'user-mobile'" type="text" class="form-control" formControlName="mobile"
            placeholder="{{'CreateOrUpdateUser.Mobile_P' | translate }}" />

          <!-- <input-phone [isRequired]="true" [disabled]="false" [showMessages]="true"></input-phone> -->

          <div class="text-danger mt-2">
            <div *ngIf="controlHasError('required', 'mobile', form_Group)">
              {{"CreateOrUpdateUser.Mobile_Required" | translate}}
            </div>
            <div *ngIf="controlHasError('pattern', 'mobile', form_Group)">
              {{"CreateOrUpdateUser.Mobile_String" | translate}}
            </div>
            <div
              *ngIf="controlHasError('minlength', 'mobile', form_Group) || controlHasError('maxlength', 'mobile', form_Group)">
              {{"CreateOrUpdateUser.Mobile_Length" | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-12">
        <div class="form-group">
          <label for="text" class="mb-3">
            {{"CreateOrUpdateUser.Permissions" | translate}}
            <span class="text-danger"> *</span>
          </label>
          <ng-select [qcId]="'user-permissions'" width="100%" [items]="displayedPermissions" bindValue="id"
            bindLabel="name" formControlName="permissions" [multiple]="true" [placeholder]="'Global.Choose' | translate"
            (change)="selectPermission($event)">
          </ng-select>

          <div class="text-danger mt-2">
            <div *ngIf="controlHasError('required', 'permissions', form_Group)">
              {{"CreateOrUpdateUser.Permission_Required" | translate}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="activeModal.dismiss()">رجوع</button>
    <button type="submit" class="btn btn-green pl-5 pr-5">{{!user?.id ? 'إضافة' : 'تعديل'}}</button>
  </div>
</form>